import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/features/auth/use-auth";
import { adminApi } from "@/lib/auth-api";

export const TENANTS_QUERY_KEY = ["tenants"] as const;

export function useTenants() {
	const { hasRole } = useAuth();
	const isSuperAdmin = hasRole("super_admin");

	return useQuery({
		queryKey: TENANTS_QUERY_KEY,
		queryFn: () => adminApi.getTenants(),
		enabled: isSuperAdmin,
		staleTime: 10 * 60 * 1000,
	});
}
